import React from "react";
import { useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";

import ClearIcon from "@mui/icons-material/Clear";
import { createContact } from "../../../../store/service/proposalAndContractService";
import LoaderSpin from "../../Commons/LoaderSpin";

import TextStyles from "../../../../Constants/TextStyles";
import Colors from "../../../../Constants/Colors";
import { pcActions } from "../../../../store/storage/proposalAndContractSlice";
import { validateEmail } from "../../Commons/utils";

const AddContactModal = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.proposalAndContract.isLoading);
  const selectedData = useSelector(
    (state) => state.proposalAndContract.selectedData
  );
  const selectedClientContacts = useSelector(
    (state) => state.proposalAndContract.selectedClientContacts
  );

  const {
    register,
    reset,
    setValue,
    formState: { errors, isDirty, isValid },
    handleSubmit,
  } = useForm();

  const formsubmit = (item) => {
    const Obj = {
      client_id:
        selectedData && selectedData.client_id && selectedData.client_id._id,
      contact_name: item.contact_name,
      contact_email: item.email,
    };

    const oldClientContacts = [...selectedClientContacts];
    const newClientContacts = [
      ...oldClientContacts,
      { contact_name: item.contact_name, email: item.email.toLowerCase() },
    ];

    dispatch(createContact(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        dispatch(pcActions.selectedClientContactAction(newClientContacts));
        handleClose();
        reset();
        message.success(`${data.payload.message}`);
      } else {
        message.error(`${data.error.message}!`);
      }
    });
  };

  return (
    <Modal
      scrollable
      show={show}
      onHide={handleClose}
      contentClassName="ToMakeModalBorderRudius12px"
      centered
    >
      <form
        onSubmit={handleSubmit(formsubmit)}
        className="modal-content"
        style={{ height: "100%" }}
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <TextStyles.FontSize20px>Add Contact</TextStyles.FontSize20px>
          <ClearIcon
            sx={{
              color: Colors.font2,
              cursor: "pointer",
              opacity: 0.7,
              "&:hover": {
                opacity: 1,
              },
            }}
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Body>
          <TextStyles.FontSize14px className="mb-3">
            <label htmlFor="contact_name" className="mb-2">
              Name
            </label>
            <TextStyles.InputRectangle
              invalid={errors.contact_name}
              id="contact_name"
              placeholder="Name"
              name="contact_name"
              {...register(`contact_name`, {
                required: "Contact can't be empty.",
                validate: (value) => {
                  let trimedLength = value.trim().length;
                  if (trimedLength === 0) {
                    return "Contact can't be empty.";
                  }
                  return true;
                },
              })}
            />
            {errors.contact_name && (
              <TextStyles.InValidFeedback>
                {errors.contact_name.message}
              </TextStyles.InValidFeedback>
            )}
          </TextStyles.FontSize14px>
          <TextStyles.FontSize14px className="mb-3">
            <label htmlFor="email" className="mb-2">
              Email
            </label>
            <TextStyles.InputRectangle
              invalid={errors.email}
              id="email"
              placeholder="Email"
              name="email"
              {...register("email", {
                required: "Email is required.",
                validate: validateEmail,
                onBlur: (e) =>
                  setValue("email", e.target.value.trim().toLowerCase()),
              })}
            />
            {errors.email && (
              <TextStyles.InValidFeedback>
                {errors.email.message}
              </TextStyles.InValidFeedback>
            )}
          </TextStyles.FontSize14px>
        </Modal.Body>
        <Modal.Footer style={{ display: "inline-block" }}>
          <div className="d-flex gap-3 justify-content-between">
            <TextStyles.CancelButton onClick={handleClose}>
              Cancel
            </TextStyles.CancelButton>
            <TextStyles.Button disabled={!isDirty || !isValid || isLoading}>
              {isLoading ? <LoaderSpin /> : "Add contact"}
            </TextStyles.Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddContactModal;
